// extracted by mini-css-extract-plugin
export default {"selectWrapper":"fbROd1Ti1G9xtpSa4XQd"};